import { render, staticRenderFns } from "./TipoImportacion.vue?vue&type=template&id=1eb0c728"
import script from "./TipoImportacion.vue?vue&type=script&lang=js"
export * from "./TipoImportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports